var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"invoice-flow__logo-wrapper"},[_c('div',{staticClass:"method-options-card-header__icon",style:(_vm.logoStyles)}),_c('div',[_vm._v(_vm._s(_vm.$t(_vm.method.name)))])]),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }